module.exports = __webpack_public_path__ + "img/back pocket bag height.c561c5c9.png";